import store from 'store'
import EventAggregator from './event_aggregator'
import LocaleService from './locale_service'

const UnitSystem = {
  LOCAL_STORAGE_KEY: 'unitSystem',

  _systems: {
    imperial: {
      name: 'imperial',
      distance: 'feet',
      speed: 'mph'
    },
    metric: {
      name: 'metric',
      distance: 'km',
      speed: 'kph'
    }
  },

  imperialLanguages: {
    en: true
  },

  _current: null,

  getCurrent() {
    return this._current != null
      ? this._current
      : (this._current = this._getFromLocalStorage() || this._getFromLocale())
  },

  _getFromLocalStorage() {
    return this._systems[store.get(this.LOCAL_STORAGE_KEY)]
  },

  _getFromLocale() {
    if (this.imperialLanguages[LocaleService.getPageLocale()]) {
      return this._systems.imperial
    } else {
      return this._systems.metric
    }
  },

  setCurrent(name) {
    if (this._systems[name] == null) {
      throw new Error(`Invalid unit system '${name}'`)
    }

    if (store.get(this.LOCAL_STORAGE_KEY) === name) {
      return
    }

    store.set(this.LOCAL_STORAGE_KEY, name)
    this._current = this._systems[name]
    EventAggregator.trigger('unitSystem:change', name)
  },

  getImperial() {
    return this._systems.imperial
  },

  getMetric() {
    return this._systems.metric
  },

  reset() {
    return (this._current = null)
  }
}

export default UnitSystem
